import { 
  InformationCircleIcon, 
  PhoneIcon, 
  EnvelopeIcon, 
  ClockIcon, 
  MapPinIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

export default function Footer() {
  return (
    <footer className="bg-[#0b0c10] text-gray-300 border-t border-red-950 pt-16 pb-8 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
        
        {/* About Us Column */}
        <div className="flex flex-col space-y-4">
          <div className="flex items-center space-x-2">
            <span className="h-2 w-2 rounded-full bg-red-600 animate-pulse"></span>
            <h3 className="text-xl font-bold text-white tracking-wider uppercase font-sans">
              SAJIES GLOBAL
            </h3>
          </div>
          <span className="text-xs text-blue-500 font-semibold tracking-widest uppercase -mt-3">
            Synergy Limited
          </span>
          <p className="text-sm text-gray-400 leading-relaxed font-light text-justify">
            Sajies Global Synergy Limited is a technology and quality-driven automotive expert. Our vision is to deliver world-class sales, flexible vehicle financing, and advanced diagnostics to every individual at highly competitive rates.
          </p>
          <div className="flex space-x-4 pt-3">
            {[
              { href: "https://facebook.com/sajiesglobalsynergy", src: "/img/facebook.svg", label: "Facebook" },
              { href: "https://instagram.com/sajiesglobalsynergy", src: "/img/instagram.svg", label: "Instagram" },
              { href: "https://tiktok.com/@sajiesglobalsynergy", src: "/img/tiktok.svg", label: "Tiktok" }
            ].map((soc) => (
              <a 
                key={soc.label}
                href={soc.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:scale-110 transition-transform duration-200 bg-white/5 hover:bg-red-600 p-2.5 rounded-full"
                aria-label={soc.label}
              >
                <img src={soc.src} alt={`${soc.label} Icon`} className="h-5 w-5 invert" />
              </a>
            ))}
          </div>
        </div>

        {/* Useful Links Column */}
        <div className="flex flex-col space-y-4">
          <h3 className="text-lg font-bold text-white tracking-wider border-b border-gray-800 pb-2">
            Useful Links
          </h3>
          <ul className="space-y-3.5">
            {[
              { to: "/about", label: "About Us", icon: <InformationCircleIcon className="h-5 w-5 mr-3 text-blue-500" /> },
              { to: "/book-inspection", label: "Book Inspection", icon: <ClockIcon className="h-5 w-5 mr-3 text-blue-500" /> },
              { to: "/browse", label: "Browse Cars", icon: <SparklesIcon className="h-5 w-5 mr-3 text-blue-500" /> },
              { to: "/connect", label: "Contact Us", icon: <EnvelopeIcon className="h-5 w-5 mr-3 text-blue-500" /> }
            ].map((link) => (
              <li key={link.label}>
                <a 
                  href={link.to} 
                  className="flex items-center text-sm text-gray-400 hover:text-red-500 hover:translate-x-1.5 transition-all duration-250 ease-in-out"
                >
                  {link.icon}
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact/Location Column */}
        <div className="flex flex-col space-y-4">
          <h3 className="text-lg font-bold text-white tracking-wider border-b border-gray-800 pb-2">
            Connect & Visit
          </h3>
          
          <div className="space-y-4">
            <div className="flex items-start">
              <MapPinIcon className="h-6 w-6 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-400 leading-relaxed">
                Km 74, Lekki - Epe Express Way, Ikota Second Gate, Lekki, Lagos State, Nigeria
              </p>
            </div>

            <div className="flex items-center">
              <PhoneIcon className="h-5 w-5 text-red-600 mr-3 flex-shrink-0" />
              <a href="tel:+2347010640278" className="text-sm text-gray-400 hover:text-white transition-colors">
                (+234) 7010640278
              </a>
            </div>

            <div className="flex items-center">
              <EnvelopeIcon className="h-5 w-5 text-red-600 mr-3 flex-shrink-0" />
              <a href="mailto:sajiesglobalsynergyltd@gmail.com" className="text-sm text-gray-400 hover:text-white transition-colors break-all">
                sajiesglobalsynergyltd@gmail.com
              </a>
            </div>

            <div className="flex items-start">
              <ClockIcon className="h-5 w-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-400">
                Mon - Sat: 8:00 AM - 6:00 PM <br />
                <span className="text-red-500 font-semibold">Sunday: Closed</span>
              </p>
            </div>
          </div>
        </div>

      </div>

      <div className="mt-12 pt-8 border-t border-gray-900 text-center text-xs text-gray-500 px-4">
        <p>© 2026 Sajies Global Synergy Limited. All rights reserved.</p>
      </div>
    </footer>
  );
}
